import Vue from 'vue';
import Vuex from 'vuex';
import { WowClass } from './types/WowClass';
import Prismic from 'prismic-javascript';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    classes: [],
    class: {},
    startPageText: '',
  },
  mutations: {
    setClasses(state, classes) {
      state.classes = classes;
    },
    setClass(state, c) {
      state.class = c;
    }
  },
  actions: {
    loadClasses({ commit }) {
      Prismic.getApi("https://wowarena.prismic.io/api/v2", {}).then(function (api: any) {
        return api.query(Prismic.Predicates.at('document.type', 'class'), { fetchLinks: ['trait.name', 'trait.abbreviation'] }); // An empty query will return all the documents
      }).then(function (response) {
        console.log("Documents: ", response.results);
        const classes: WowClass[] = [];
        response.results.forEach((doc: any) => {
          doc.data.uid = doc.uid;
          classes.push(doc.data);
        });
        commit('setClasses', classes);
      }, function (err) {
        console.log("Something went wrong: ", err);
      });
    },
    loadClass({ commit }, uid: string) {
      commit('setClass', {});
      Prismic.getApi("https://wowarena.prismic.io/api/v2", {}).then(function (api) {
        return api.getByUID('class', uid, { fetchLinks: [ 'trait.name', 'skill.name', 'item.name', 'item.description'] });
      }).then((response) => {
        console.log('setClass', response.data);
        commit('setClass', response.data);
      }).then((err) => {
        console.log(err);
      });
    },
  },
});
